<template>
  <div>
    <v-btn
      v-if="reservable"
      small
      :color="gray"
      style="margin: 10px 20px 10px 0;float:right;"
      @click.stop="handleShowMoreInfo"
      elevation="0"
    >
      {{ $t('booking.reservable', locale).toUpperCase() }}
    </v-btn>
    <v-btn
      v-else
      small
      dark
      :color="secondaryColor"
      style="margin: 10px 10px 10px 0;float:left;"
      @click.stop="handleShowMoreInfo"
      elevation="0"
    >
      {{ $t('booking.moreInfo', locale).toUpperCase() }}
    </v-btn>
    <v-dialog
      content-class="more-info"
      v-model="showMoreInfo"
      style="max-width: 400px !important;"
    >
      <v-card style="border-radius:5px;">
        <v-card-text style="padding: 0 0 40px 0;">
          <v-layout wrap>
            <v-flex xs12 style="padding: 20px 20px 0 20px">
              <div 
                style="cursor: pointer;padding-right:20px;padding-top:10px;z-index: 300;
                        right:0;margin-top:-25px;margin-right:-15px;color:red;position:absolute"
                @click="showMoreInfo = false"
              >
              <v-btn fab x-small>
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
              </div>
              <v-img
                 :src="event.image.replace('_dtouch/', '/')"
                lazy-src="https://www.dviewcontent.com/activity/acttiv/images/loaging.jpg"
                 width="100%"
                 aspect-ratio="1.7"
                 class="grey lighten-2"
              />
            </v-flex>
            <v-flex
              xs12
              class="title"
              :style="{ 'color': titleColor }"
            >
              {{ getTranslation(event.title, locale) .toUpperCase() }}
            </v-flex>
            <v-flex
              xs6
              style="text-align: left;padding: 10px 0 10px 20px;font-family: Roboto Condensed;font-size:20px !important;"
            >
              <v-icon
                :style="{ 'color': event.active ? 'rgb(85,173,11)' : timeColor}"                  
                dark
                class="activity-button"
                style="margin: -3px 0 0 0;margin-font-weight: 500;font-size:1.2rem"
              >
                mdi-clock-outline
              </v-icon>
              <span
                :style="{ 'color': event.active ? 'rgb(85,173,11)' : timeColor}"                  
                style="font-weight: 500;"
              >
                {{ event.time }}
              </span>
            </v-flex>
            <v-flex xs6
              style="padding: 10px 20px 0 0;text-align:right;"
            >
            <v-spacer />
              <div
                   v-if="event.reservable"
                   style="padding:0;"
              >
                <span>
                   {{ $t('booking.reservable', locale).toUpperCase() }}
               </span>
              </div>
            </v-flex>
            <v-flex
              xs12
              style="text-align: left;padding: 10px 0 10px 20px;font-family: Roboto Condensed;font-size:20px !important;"
            >
              <spam v-if="event.PVPHosted">
                {{$t('booking.PVPHosted', locale)}}: <b style="margin: 0 15px 0 10px;"> {{event.PVPHosted}}</b>
              </spam>
              <spam v-if="event.PVPNoHosted">
                {{$t('booking.PVPNoHosted', locale)}}: <b> {{event.PVPNoHosted}}</b>
              </spam>
            </v-flex>
            <v-flex xs12
                v-if="event.description"
                class="description"
                :style="{ 'color': contentColor }"
             >
                {{getTranslation(event.description, locale)}}
             </v-flex>
            <v-flex xs12
                v-if="event.place"
                class="description"
                :style="{ 'color': contentColor }"
             >
                {{getTranslation(event.place, locale)}}
             </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import utils from '@/services/utils'
export default {
  name: 'MoreInfo',
  components: {
  },
  props: {
    reservable: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      required: true
    },
    primaryColor: {
      type: String,
      required: true,
    },
    secondaryColor: {
      type: String,
      required: true,
    },
    titleColor: {
      type: String,
      required: true,
    },
    contentColor: {
      type: String,
      required: true,
    },
    timeColor: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMoreInfo: false,
      //addToCalendarButtons: '',
    }
  },
   computed: {
      dtouchIsTouchPublic () {
         return this.$store.state.app.dtouchIsTouchPublic
      },
      isTotem () {
        //return this.$route.path === '/totem'
        return this.$route.path === '/totem' || utils.isTotem()
      },
   },
  methods: {
    getTranslation (v, locale) {
      if (!v) return ''
      if (v[locale]) return v[locale]
      if (v['es']) return v['es']
      return v[0]
    },
    handleShowMoreInfo () {
      this.showMoreInfo = true
    },
    handleShowCalendar () {
      /*
      const start = new Date(Date.parse(this.start, 'Y-m-d'))
      const end = new Date(Date.parse(this.end, 'Y-m-d'))

      const startTime = this.startTime.split(':')
      start.setHours(startTime[0], startTime[1], '00')
      const endTime = this.endTime.split(':')
      end.setHours(endTime[0], endTime[1], '00')
      const duration = parseInt((end - start) / (1000 * 60), 10)

      // eslint-disable-next-line
      const myCalendar = createCalendar({
        options: {
          class: 'my-class',
          id: 'my-id'
        },
        data: {
          title: this.title,
          start: start,
          duration: duration,
          end: end,
          address: '',
          description: this.description
        }
      })
      let aux = myCalendar.replace(new RegExp('######', 'g'), this.color)
      this.addToCalendarButtons = aux
      this.showAddToCalendar = true
        */
    }
  }
}
</script>
<style>
.more-info {
  max-width: 600px!important;
  width: auto;

  overflow-y: scroll; 
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.more-info::-webkit-scrollbar {
  display: none; /* For WebKit browsers */
}
.more-info .title {
  text-align: left;
  padding:20px 20px 5px 20px;
  line-height:1.2;
  font-size: 1.5rem !important;
  font-weight:300;
}
.more-info .description {
  padding: 10px 20px 0 20px;
  text-align: left;
  font-family: Roboto Condensed;
  line-height:1.2;
  font-size:16px;
  font-weight:300;
}
.btnAdd {
  border: 1px solid!important;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px;
  color: red;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 2px;
}
.btnAdd:hover {
  border: 1px solid !important;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px;
  color: red;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 2px;
  background-color: #d4d9dc;
}
</style>


